<template>
  <div class="addAreaDalog">
    <el-dialog
      title="新增职员"
      width="750px"
      append-to-body
      @close="closeDialog"
      :visible.sync="visible"
      :show="show"
    >
      <div class="content_box333">
        <InputOne
          class="base_select_sty6"
          v-model="fromdatas.FullName"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="职员名称"
          field="FullName"
          reg="empty"
          :error="serror"
        />
        <InputOne
          class="base_select_sty9"
          v-model="fromdatas.BaseCode"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="职员编号"
          field="BaseCode"
          reg="empty"
          :error="BaseCodeerror"
        />
        <!-- <div class="inputicon3 base_select_sty9 base_select" @dblclick="clickSearch">
          <span class="inputMust_text">职员部门</span>
          <el-input v-model="fromdatas.DeptName" :disabled="true"></el-input>
          <i class="el-icon-search icons" v-show="iconsearch" @clickSearch="clickSearch"></i>
        </div>-->
        <InputOne
          class="base_select_sty9 margin_l_ isdisable"
          v-model="fromdatas.DeptName"
          @clickFocus="doFocus"
          @dblclick="clickSearch"
          @clickSearch="clickSearch"
          @changeVal="inputVal"
          name="职员部门"
          :isdisable="true"
          field="DeptName"
          :icon2="true"
        />

        <!-- <SelectOne
            class="base_select_sty9 margin_l_ SelectOne"
            v-model="fromdatas.Sex"
            name="性别"
            :options="maleData"
            @valchaneg="select"
        />-->
        <div class="selectbox">
          <span>性别</span>
          <el-select v-model="Sex">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <!-- <div class="inputicon3 base_select_sty9 base_select" @dblclick="clickStock">
          <span class="inputMust_text">仓库</span>
          <el-input v-model="fromdatas.StockName" :disabled="true"></el-input>
          <i class="el-icon-search icons" v-show="iconsearch" @click="clickStock"></i>
        </div>-->
        <InputOne
          class="base_select_sty9 margin_l_ isdisable"
          v-model="fromdatas.StockName"
          @clickFocus="doFocus"
          @dblclick="clickStock"
          @clickSearch="clickStock"
          @changeVal="inputVal"
          :isdisable="true"
          name="仓库"
          field="StockName"
          :icon2="true"
        />
        <div class="inputicon3 base_select_sty9">
          <span class="inputMust_text">入职时间</span>
          <div class="date_picker">
            <el-date-picker v-model="InJobDate" type="date" placeholder="选择日期"></el-date-picker>
          </div>
        </div>
        <div class="inputicon3 base_select_sty9 margin_l_">
          <span class="inputMust_text">生日</span>
          <div class="date_picker">
            <el-date-picker v-model="Birthday" align="right" type="date" placeholder="选择日期"></el-date-picker>
          </div>
        </div>
        <InputOne
          class="base_select_sty9"
          v-model="fromdatas.Incumbency"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="职务"
          :isMust="false"
          field="Incumbency"
        />
        <InputOne
          class="base_select_sty9 margin_l_"
          v-model="fromdatas.EducateLevel"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="教育程度"
          :isMust="false"
          field="EducateLevel"
        />
        <InputOne
          class="base_select_sty9"
          v-model="fromdatas.Email"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="邮箱"
          :isMust="false"
          field="Email"
        />
        <InputOne
          class="base_select_sty9 margin_l_"
          v-model="fromdatas.EveryTotal"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="每单优惠限额"
          :isMust="false"
          field="EveryTotal"
          reg="float"
        />
        <InputOne
          class="base_select_sty6"
          v-model="fromdatas.IDCard"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="证件号"
          :isMust="false"
          field="IDCard"
        />
        <InputOne
          class="base_select_sty6"
          v-model="fromdatas.LinkTel"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="联系电话"
          :isMust="false"
          field="LinkTel"
        />
        <InputOne
          class="base_select_sty6"
          v-model="fromdatas.HandTel"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="手机"
          :isMust="false"
          :isdisable="fromdatas.HandCheck==1?true:false"
          field="HandTel"
        />
        <InputOne
          class="base_select_sty6"
          v-model="fromdatas.Address"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="地址"
          :isMust="false"
          field="Address"
        />
        <InputOne
          class="base_select_sty6"
          v-model="fromdatas.Memo"
          @clickFocus="doFocus"
          @changeVal="inputVal"
          name="备注"
          :isMust="false"
          field="Memo"
        />
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addsaveClick('fromdatas')">保存新增</el-button>
          <el-button type="primary" @click="saveClick('fromdatas')">保存返回</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="职员部门分类" :visible.sync="dialogVisible" width="330px">
      <div class="member">
        <div class="member_box">
          <el-tree
            :data="data"
            :props="defaultProps"
            accordion
            icon-class="iconfont icon-file-close "
            @node-click="handleNodeClick"
            node-key="id"
            :default-expanded-keys="[0]"
          ></el-tree>
        </div>
      </div>
      <div class="member2">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="footer">确定</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="仓库分类" :visible.sync="dialogVisibleck" width="330px">
      <div class="member">
        <div class="member_box">
          <el-tree
            :data="datack"
            :props="defaultPropsck"
            accordion
            icon-class="iconfont icon-file-close "
            @node-click="handleNodeClickck"
            node-key="id"
            :default-expanded-keys="[0]"
          ></el-tree>
        </div>
      </div>
      <div class="member2">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisibleck = false">取消</el-button>
          <el-button type="primary" @click="footerck">确定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
// 以下为工具库
import vPinyin from "@/utils/PyConversion.js"; // 自动生成拼音助记码

import tool from "@/utils/tool.js";
// import local from "../../../utils/local"; //本地缓存存取
// import session from "../../../utils/session"; //本地缓存存取
// import InputOne from "../../base/InputOne/InputOne";
// import treehistory from ".././treedata/treedata";

export default {
  components: {
    // InputOne,
    // treehistory
  },
  data() {
    return {
      datasck: { id: "", label: "" },
      datack: [],
      defaultPropsck: {
        children: "children",
        label: "label"
      },
      datas: { id: "", label: "" },
      data: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      dialogVisible: false,
      dialogVisibleck: false,
      iconsearch: true,
      visible: this.show,
      Sex: "男", //性别
      options: [
        {
          value: "男",
          label: "男"
        },
        {
          value: "女",
          label: "女"
        }
        // {
        //    value: "2",
        //   label: "不详"
        // }
      ],
      Birthday: "", //出生日期
      InJobDate: "", //入职时间
      fromdatas: {
        FullName: "", //职员名称
        BaseCode: "", //职员编号
        DeptId: 0, //部门id
        DeptName: "全部部门", //职员部门
        KTypeId: 0, //仓库ID
        StockName: "全部仓库", //仓库名称
        IDCard: "", //证件号
        Birthday: "", //出生日期
        InJobDate: "", //入职时间
        LinkTel: "", //联系电话
        Address: "", //地址
        HandTel: "", //手机
        EducateLevel: "", //教育程度
        Incumbency: "", //职务
        Memo: "", //备注
        Email: "", //邮箱
        EveryTotal: 0, // 教育程度
        PyNo: "", //助记码
        HandCheck: 0 //判定手机号是否可更改 0-可更改 1-不可更改
      },
      serror: "",
      BaseCodeerror: ""
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fieldData: String
  },
  methods: {
    handleNodeClickck(data) {
      this.datasck = data;
    },
    footerck() {
      this.fromdatas.StockName = this.datasck.label;
      this.fromdatas.KTypeId = this.datasck.id;
      this.dialogVisibleck = false;
    },
    handleNodeClick(data) {
      this.datas = data;
    },
    footer() {
      this.fromdatas.DeptName = this.datas.label;
      this.fromdatas.DeptId = this.datas.id;
      this.dialogVisible = false;
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
    },
    //   职员部门 双击 或点击搜索
    clickSearch() {
      this.clicknede();
      this.dialogVisible = true;
    },
    clicknede() {
      // 取值
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let params = {
        user_id: userid, //用户id
        session_id: sessionid //用户凭证
      };
      let jparams = JSON.stringify(params);
      let jparams_tree = { jparams: jparams };
      this.request.post("/index/Department/getlist", jparams_tree).then(res => {
        let { status, data, tree } = res;
        let aa = [];
        for (let i = 0; i < tree.length; i++) {
          const element = tree[i];
          aa.push(element);
        }
        this.data = aa;
      });
    },
    // 仓库 双击 或点击搜索
    clickStock() {
      this.clicknedeck();
      this.dialogVisibleck = true;
    },
    clicknedeck() {
      // 取值
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let params = {
        user_id: userid, //用户id
        session_id: sessionid //用户凭证
      };
      let jparams = JSON.stringify(params);
      let jparams_tree = { jparams: jparams };
      this.request.post("/index/Stock/getlist", jparams_tree).then(res => {
        let { status, data, tree } = res;
        let aa = [];
        for (let i = 0; i < tree.length; i++) {
          const element = tree[i];
          aa.push(element);
        }
        this.datack = aa;
      });
    },
    // 保存新增
    addsaveClick() {
      if (this.fromdatas.FullName == "") {
        this.serror = "该值不能为空";
      }
      if (this.fromdatas.BaseCode == "") {
        this.BaseCodeerror = "该值不能为空";
      }
      if (this.fromdatas.FullName != "" && this.fromdatas.BaseCode != "") {
        let userid = tool.getLocal("userid");
        let sessionid = tool.getLocal("sessionid");
        // let ParentNoNameStock = tool.getSession("ParentNoNameStock");
        // let ParentNoNamePerson = tool.getSession("ParentNoNamePerson");
        let params = {
          user_id: userid, //用户id
          session_id: sessionid, //用户凭证
          ParentNo: 0,
          BaseCode: this.fromdatas.BaseCode,
          FullName: this.fromdatas.FullName,
          Name: this.fromdatas.FullName,
          PyNo: this.fromdatas.PyNo,
          Sex: this.Sex,
          DeptId: this.fromdatas.DeptId,
          LinkTel: this.fromdatas.LinkTel,
          HandTel: this.fromdatas.HandTel,
          EveryTotal: this.fromdatas.EveryTotal,
          Address: this.fromdatas.Address,
          KTypeId: this.fromdatas.KTypeId,
          Memo: this.fromdatas.Memo,
          Email: this.fromdatas.Email,
          InJobDate: this.InJobDate,
          IDCard: this.fromdatas.IDCard,
          Incumbency: this.fromdatas.Incumbency,
          Birthday: this.Birthday,
          EducateLevel: this.fromdatas.EducateLevel,
          IsDir: 0
        };
        // console.log(params);

        let jparams = JSON.stringify(params);
        let jparams_save = { jparams: jparams };
        // 向后端发送请求
        this.request.post("/index/Person/add", jparams_save).then(res => {
          // console.log(res);

          let { status, description } = res;
          if (status == 0) {
            // 弹成功提示
            this.$message({
              showClose: true,
              message: description,
              type: "success",
              duration: 1000
            });
            this.Initialization();
            this.BaseCodes();
          } else {
            this.$message({
              message: description,
              type: "warning"
            });
          }
        });
        this.BaseCodeerror = "";
        this.serror = "";
      }
    },
    // 保存返回
    saveClick() {
      if (this.fromdatas.FullName == "") {
        this.serror = "该值不能为空";
      }
      if (this.fromdatas.BaseCode == "") {
        this.BaseCodeerror = "该值不能为空";
      }
      if (this.fromdatas.FullName != "" && this.fromdatas.BaseCode != "") {
        // let addStaffdata = tool.getSession("addStaffdata");

        // let ParentNoNamePerson = tool.getSession("ParentNoNamePerson");
        // 取值
        let userid = tool.getLocal("userid");
        let sessionid = tool.getLocal("sessionid");
        //  新增

        // 收集参数
        let params = {
          user_id: userid, //用户id
          session_id: sessionid, //用户凭证
          ParentNo: 0,
          BaseCode: this.fromdatas.BaseCode,
          FullName: this.fromdatas.FullName,
          Name: this.fromdatas.FullName,
          PyNo: this.fromdatas.PyNo,
          Sex: this.Sex,
          // DeptId: ParentNoNamePerson.id, //部门ID
          DeptId: this.fromdatas.DeptId,
          // KTypeId: ParentNoNameStock.id, //仓库ID
          LinkTel: this.fromdatas.LinkTel,
          HandTel: this.fromdatas.HandTel,
          Address: this.fromdatas.Address,
          KTypeId: this.fromdatas.KTypeId,
          EveryTotal: this.fromdatas.EveryTotal,
          Memo: this.fromdatas.Memo,
          Email: this.fromdatas.Email,
          InJobDate: this.InJobDate,
          IDCard: this.fromdatas.IDCard,
          Incumbency: this.fromdatas.Incumbency,
          Birthday: this.Birthday,
          EducateLevel: this.fromdatas.EducateLevel,
          DepartName: this.fromdatas.DeptName,

          IsDir: 0
        };
        let jparams = JSON.stringify(params);
        let jparams_save = { jparams: jparams };
        // console.log(jparams_save);

        // 向后端发送请求
        this.request.post("/index/Person/add", jparams_save).then(res => {
          let { status, description } = res;
          if (status == 0) {
            // 弹成功提示
            this.$message({
              showClose: true,
              message: description,
              type: "success",
              duration: 1000
            });
            this.Initialization();
            this.closeDialog();
            this.addWareShow = false;
          } else {
            this.$message({
              message: description,
              type: "warning"
            });
          }
        });
        this.BaseCodeerror = "";
        this.serror = "";
      }
    },
    // 初始化弹框
    Initialization() {
      this.fromdatas = {
        FullName: "", //职员名称
        BaseCode: "", //职员编号
        DeptId: this.fromdatas.DeptId, //部门id
        DeptName: this.fromdatas.DeptName, //职员部门
        KTypeId: this.fromdatas.KTypeId, //仓库ID
        StockName: this.fromdatas.StockName, //仓库名称
        IDCard: "", //证件号
        LinkTel: "", //联系电话
        Address: "", //地址
        HandTel: "", //手机
        EducateLevel: "", //教育程度
        EveryTotal: 0, // 每单限额
        Incumbency: "", //职务
        Memo: "", //备注
        PyNo: "" //助记码
      };
      this.Sex = "男"; //性别
      this.Birthday = new Date(); // 默认显示为当天时间
      //   this.Birthday = this.convertToLateDate();
      this.InJobDate = new Date(); // 默认显示为当天时间
      //   this.InJobDate = this.convertToLateDate();
    },
    // 当前input值改变
    inputVal(data, fieldData) {
      this.fromdatas[fieldData] = data;
      this.fromdatas.PyNo = vPinyin.makePy(this.fromdatas.FullName);
    },
    doFocus() {},
    convertToLateDate() {
      var data = new Date();
      var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000 * 30);
      // console.log(Da);
      // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
      // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
      // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
      // var Da = new Date()
      var y = Da.getFullYear();
      var m = Da.getMonth() + 1;
      var d = Da.getDate();
      var H = Da.getHours();
      var mm = Da.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      H = H < 10 ? "0" + H : H;
      return y + "-" + m + "-" + d + " " + H + ":" + mm;
    },
    BaseCodes() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        ParentNo: 0,
        table: "Person"
      };
      this.request
        .post("/index/common/get_basecode", { jparams: JSON.stringify(params) })
        .then(res => {
          let { status, BaseCode } = res;
          if (status == 0) {
            this.fromdatas.BaseCode = BaseCode;
          }
        });
    }
  },
  mounted() {
    var vm = this;
    vm.Birthday = new Date(); // 默认显示为当天时间
    // vm.Birthday = vm.convertToLateDate();
    vm.InJobDate = new Date(); // 默认显示为当天时间
    // vm.InJobDate = vm.convertToLateDate();
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    visible: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.BaseCodes();
        }
      }
    }
  }
};
</script>

<style lang="less">
// .addDalog{
.el-dialog__header {
  background: rebeccapurple;
  // background: #4990d7;
  padding: 10px 10px 0;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px;
}
.content_box333 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .base_select_sty6 {
    width: 99.5%;
    margin-top: 10px;
  }
  .base_select_sty9 {
    width: 332px;
    margin-top: 15px;
    line-height: 27px;
    padding: 0;
  }

  .margin_l_ {
    margin-left: 41px;
  }
  .isdisable {
    cursor: pointer !important;
    .el-input__inner {
      cursor: pointer !important;
    }
  }
  .dialog-footer {
    width: 100%;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-pack: end;
    box-pack: end;
    margin: 20px 0 10px;
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 258px;
}
.selectbox {
  width: 332px;
  height: 28px;
  margin-top: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;

  span {
    font-size: 14px;
    margin-left: 5px;
    color: #000;
    font-weight: bold;
  }

  .el-input__inner {
    text-indent: 15px;
    width: 293px;
    padding: 0;
    height: 28px;
    border: none;
  }

  .el-input__icon {
    line-height: 28px;
  }
}
.inputicon3 {
  width: 100%;
  height: 28px;
  display: flex;
  //   justify-content: flex-end;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;

  .el-input__inner {
    padding-right: 30px;
    height: 28px;
    /* line-height: 28px; */
    border: aliceblue;
  }

  .inputMust_text {
    color: #000;
    height: 100%;
    text-align: center;
    white-space: nowrap;
    line-height: 28px;
    font-size: 14px;
    margin-left: 5px;
    font-weight: bold;
  }

  .el-input__icon {
    line-height: 29px;
  }
}

.inputicon3:hover {
  border: 1px solid rgb(22, 123, 238) !important;

  .inputMust_text {
    color: rgb(22, 123, 238);
  }
}
.member {
  width: 100%;
  height: 300px;
  border: 1px solid #ccc;
  overflow: hidden;
  .member_box {
    width: 106%;
    height: 300px;
    overflow-y: scroll;
  }
  .el-tree-node__expand-icon {
    font-size: 20px;
  }
  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg) !important;
    transform: rotate(0deg) !important;
  }
  .el-tree-node__expand-icon.expanded::before {
    content: "\e62e";
    font-size: 22px;
  }
}
.member2 {
  margin-top: 7px;
  display: flex;
  justify-content: flex-end;
  .el-dialog__footer {
    padding: 0px 18px 6px;
  }
  .dialog-footer {
    // margin-left: 156px;
    .el-button {
      padding: 8px 18px;
    }
  }
}
// }
</style>
         


// WEBPACK FOOTER //
// src/components/Dialog/AddMember/AddMember.vue